import { observable } from 'mobx';

export type JournalEntryType = 'normal' | 'prepaid_travel_voucher';

export const JournalEntryTypeMap: Record<JournalEntryType, string> = {
  normal: '通常',
  prepaid_travel_voucher: '前払旅行券'
} as const;

export const AccountRecordTypeMap = {
  return_at: '帰着日',
  ticketing_at: '仕入日',
  started_at: '出発日'
} as const;

export type SuppliedItemResponseArgs = {
  id: number;
  name: string;
  code: string;
  supplier_id: number;
  payment_method_id?: number;
  supplier_name?: string;
  supplier_code?: string;
  disabled: boolean;
  account_record_type: string;
  journal_entry_type: JournalEntryType;
};

export type SuppliedItemArgs = {
  id: number;
  name: string;
  code: string;
  supplierId: number;
  paymentMethodId?: number;
  supplierName?: string;
  supplierCode?: string;
  disabled: boolean;
  accountRecordType: string;
  journalEntryType: JournalEntryType;
};

export const convertSuppliedItemResponseToArgs = (response: SuppliedItemResponseArgs): SuppliedItemArgs => {
  return {
    id: response.id,
    name: response.name,
    code: response.code,
    supplierId: response.supplier_id,
    paymentMethodId: response.payment_method_id,
    supplierName: response.supplier_name,
    supplierCode: response.supplier_code,
    disabled: response.disabled,
    accountRecordType: response.account_record_type,
    journalEntryType: response.journal_entry_type
  };
};

export default class SuppliedItem {
  @observable id: number;
  @observable name: string;
  @observable code: string;
  @observable supplierId: number;
  @observable paymentMethodId?: number;
  @observable supplierName?: string;
  @observable supplierCode?: string;
  @observable disabled: boolean;
  @observable accountRecordType: string;
  @observable journalEntryType: JournalEntryType;

  constructor(args: SuppliedItemArgs) {
    this.id = args.id;
    this.name = args.name;
    this.code = args.code;
    this.supplierId = args.supplierId;
    this.paymentMethodId = args.paymentMethodId;
    this.supplierName = args.supplierName;
    this.supplierCode = args.supplierCode;
    this.disabled = args.disabled;
    this.accountRecordType = args.accountRecordType;
    this.journalEntryType = args.journalEntryType;
  }

  clone(): SuppliedItem {
    const args: SuppliedItemArgs = {
      id: this.id,
      name: this.name,
      code: this.code,
      supplierId: this.supplierId,
      paymentMethodId: this.paymentMethodId,
      supplierName: this.supplierName,
      supplierCode: this.supplierCode,
      disabled: this.disabled,
      accountRecordType: this.accountRecordType,
      journalEntryType: this.journalEntryType
    };
    return new SuppliedItem(args);
  }

  get submitParams() {
    return {
      supplier_id: this.supplierId,
      payment_method_id: this.paymentMethodId,
      name: this.name,
      code: this.code,
      disabled: this.disabled,
      account_record_type: this.accountRecordType,
      journal_entry_type: this.journalEntryType
    };
  }
}
